import { gql } from "@apollo/client";

export const MUTATION_PERSIST_ROLE = gql`
  mutation PersistRole($name: String!, $id: Float, $permissionIds: String) {
    persistRole(name: $name, id: $id, permissionIds: $permissionIds) {
      id
    }
  }
`;
